export default __webpack_public_path__ + "static/media/signin-background.6ed68fa9.svg";